import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import ProfilePicture from './ProfilePicture';
import CustomLink from './CustomLink';
import ProjectsList from './ProjectList.js';
import Skills from './Skills';
import Certifications from './Certifications';


const MainContent = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
        

      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Typography variant="h4" color="primary" fontWeight="bold">
          Welcome to Steffen's CV
        </Typography>

        <Typography variant="h6" >
            Build with REACT on AWS
        </Typography>

        <Typography variant="h5" color="text.secondary" mt={1}>
            Find my 
            <CustomLink name=" Projects, " to="projects"  ></CustomLink>
            <CustomLink name=" Skills, " to="skills" ></CustomLink>
            <CustomLink name=" Certificates " to="certificates" ></CustomLink>
           below.
        </Typography>
        <ProfilePicture></ProfilePicture>
      </Box>

      <Box>
        <Typography variant="h4" color="primary" mb={2}>
          About Me
        </Typography>
        <Typography variant="body1" color="text.secondary" mb={2}>
        Hi there! I’m Steffen, a Computer Science graduate with a knack for turning complex problems into streamlined solutions.
        Since completing my degree in 2020—with a focus on AI, mathematics, and theoretical computer science—I’ve been diving deep into the exciting worlds of Cloud Computing, Big Data, DevOps, and Automation. 
        </Typography>
        <Typography variant="body1" color="text.secondary" mb={2}>
        I thrive on building systems that work smarter, not harder, and love optimizing processes to make life easier for everyone involved.
        From designing intelligent workflows to managing large-scale data and automating tedious tasks, I’m all about creating solutions that are efficient, effective, and built to last.
        
        </Typography>
        
      </Box>

      <Box>
        <section id="projects"> </section>
        <Typography variant="h4" sx={{ py: 2 }} mb={2} color="primary" gutterBottom>
            Projects
        </Typography>
        
        <ProjectsList></ProjectsList>
      </Box>

      <Box>
        <section id="skills"> </section>
        <Typography variant="h4" sx={{ py: 2 }} mb={0} color="primary" gutterBottom>
            Skills
        </Typography>
        <Skills></Skills>
      </Box>

      <Box>
        <section id="certificats"> </section>
        <Typography variant="h4" sx={{ py: 2 }} mb={2} color="primary" gutterBottom>
            Certification
        </Typography>
        <Certifications></Certifications>
      </Box>

    </Container>
  );
};

export default MainContent;
